import { Metric } from 'web-vitals';

import { EventData } from 'lib/EventLogger/Event';
import { EventType } from 'lib/EventSchema';

const webVitalsEvent = (url: string, metricData: Metric): EventData => {
  return {
    event_type: `cwv_${metricData.name.toLowerCase()}` as EventType,
    event_context: {
      url,
      metricData,
    },
  };
};

export default webVitalsEvent;
